import { useEffect } from "react";
import { Button } from "../Button/Button";
import './RestrictedPagePopup.scss';

export const RestrictedPagePopup = ({ dictionary, loginUrl, ...props }) => {

    useEffect(() => {
        document.querySelector("html").classList.add("u-noscroll");
        document.querySelector("body").classList.add("u-noscroll");
    },[]);

    return <div className="c-restricted__account__popup__container">
        <div className="row o-row">
            <div className="c-restricted__account__popup">
                <div className="c-restricted__account__popup__content">
                    <div className="c-restricted__account__popup__content__header">
                        <h5 className="c-restricted__account__popup__content__header__title">
                            {dictionary.onlyUsers}
                        </h5>
                    </div>
                    <div className="c-restricted__account__popup__content__body">
                        {/* BOTTOM */}
                        <RestrictedAccountMessage dark={false} loginUrl={loginUrl} dictionary={dictionary} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}


const RestrictedAccountMessage = ({ dictionary, loginUrl, registerUrl, ...props }) => {

    return <div className={`c-restricted__account__loginmessage ${props.className ? props.className : ""}`}>
        <h4>
            {dictionary.loginMessage}
        </h4>
        <div className='c-restricted__account__loginmessage__footer row'>
            <div className="col-12 c-restricted__account__loginmessage__footer__right">
                <span className='c-restricted__account__loginmessage__footer__accountlabel'>
                    {dictionary.accountMessage}
                </span>
                <Button label={dictionary.login} buttonType={"secondary"} className="c-restricted__account__loginmessage__footer__login" onClick={() => window.location.href = `${loginUrl}?targetlogin=${window.location.pathname}`} />
            </div>
        </div>
    </div>
}